module.exports = __webpack_public_path__ + "media/customizations/emberly/logo-new-bd8867aa93e51823135f9cb40db998f1.png";